import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/cv/page.tsx");
